module.exports = __webpack_public_path__ + "media/images/wordpress-d1483e8ddeefa48c8de5f4fb058451da.png";